<template>
  <div>
      <secondHeader />
      <div class="main">
        <sidebar />
          <div class="tool-content">
            <notice-bar />
            <h1 class="tool-title">DiscordカスタムCSS</h1>
            <p class="tool-sub-title">Discordのオーバレイをカスタマイズできます</p>

            <div class="discord-list">
              <div @click="openModal('talkroom')" class="discord-preview">
                <img :src="carousel[0].src" class="discord-contents">
                <h2 class="discord-name">きゅーと</h2>
              </div>
              <div @click="openModal('talkroom2')" class="discord-preview">
                <img :src="carousel[1].src" class="discord-contents">
                <h2 class="discord-name">くらしっく</h2>
              </div>
            </div>

            <!-- モーダルの表示 -->
            <div v-if="showModal" class="modal" @click="closeModal">
              <div class="modal-content" @click.stop>
                <span class="close" @click="closeModal">&times;</span>
                <component :is="currentComponent" />
              </div>
            </div>

            <div class="ad-block">
              <div class="ad">
                <InFeedAdsense
                    data-ad-layout-key="-fb+5w+4e-db+86"
                    data-ad-client="ca-pub-9016794589237931"
                    data-ad-slot="4898735474">
                </InFeedAdsense>
              </div>
            </div>

            <div class="blog-area">
              <h2 class="blog-area-title">使い方はブログでチェック！</h2>
              <div class="blog-area-row">
                <div class="blog-area-thumb">
                  <img class="article-list-img" src="@/assets/article/thumnail_discord.png">
                </div>
                <div class="blog-area-desc">
                  <p>具体的な使い方や、おすすめのカスタマイズ方法はブログ記事で紹介しています。あわせてどうぞ！</p>
                  <div class="blog-area-btn">
                    <a href="https://www.ruri.info/?p=188" target="_blank" rel="noopener noreferrer">
                      <span class="check-btn">記事をチェック</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="info">
              <div class="notice">
                <p>更新履歴</p>
                  <p>2024/02/24 新デザインの追加</p>
                  <p>2023/09/23 名前部分を角まるにできるように</p>
                  <p>2023/08 画面（ブラウザソース）の幅に合わせて改行するように</p>
              </div>
            </div>

        </div>
      </div>
  </div>
</template>

<script>
import secondHeader from "../components/secondHeader.vue"
import noticeBar from "../components/notice-bar.vue"
import sidebar from "../components/sidebar.vue"
import talkroom from "../components/discord/discordTalkroom.vue"
import talkroom2 from "../components/discord/discordTalkroom2.vue"

export default{
  components:{
      secondHeader,
      sidebar,
      noticeBar,
      talkroom,
      talkroom2,
  },
  data(){
    return{
      isProduction: process.env.NODE_ENV === "production",
      showModal: false,
      currentComponent: null,
      carousel:[
        {
          index: 1,
          src: require("@/assets/carousel/discord-design1.png")
        },
        {
          index: 2,
          src: require("@/assets/carousel/discord-design2.png")
        },
        {
          index: 3,
          src: require("@/assets/carousel/new_type.png"),
          title: "準備中"
        },
      ]
    }
  },
  methods: {
    openModal(componentName) {
      this.currentComponent = componentName;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }
  }
}
</script>
<style scoped>
.main {
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  margin: 0 auto;
  background: linear-gradient(-225deg, #acb6e5 0%, #fff 25%,#fff 75%, #FFBAC3 100%);
}

.notice{
  max-width: 560px;
  padding: 0.2em 0.5em;
  margin: 2em auto;
  letter-spacing: 1.5px;
  font-size: 8px;
}
.ad-block{
  padding: 12px 12px;
  display: block;
  width: 100%;
}
.ad {
  max-height: 300px;
  max-width: 70%;
  margin: 0 auto;
  text-align: center;
  box-sizing: border-box;
  display: block;
}

.content-block {
  padding: 20px; /* 必要な余白を指定 */
  max-width: 620px;
  margin: 0 auto;

  /* グラスフォーフィズム */
  background-color: rgba(255, 255, 255, 0.1); /* 背景色 */
  border: 1px solid rgba(255, 255, 255, 0.4); /* ボーダー */
  border-right-color: rgba(255, 255, 255, 0.2);
  border-bottom-color: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  -webkit-backdrop-filter: blur(20px); /* ぼかしエフェクト */
  backdrop-filter: blur(20px);
  box-shadow: 4px 4px 8px rgb(0 0 0 / 2%);
}

.content-title {
  margin-bottom: 20px; /* 必要な余白を指定 */
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.content-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px; /* 必要な余白を指定 */
}

.content-thumb {
    flex: 0 0 auto;
    margin-right: 20px; /* 必要な余白を指定 */
    width: 50%;
}

.content-thumb img{
    object-fit: contain;
    width: 100%;
}

.content-desc {
  width: 50%;
  word-wrap: break-word;
  font-size: 14px;
  letter-spacing: 2px;
}

.content-desc a{
  text-decoration:none;
}

.ariticle-btn{
  background: linear-gradient(-225deg, #acb6e5 0%, #C5C1FF 56%, #FFBAC3 100%);
  opacity: 0.75;
  border-radius: 10px;
  padding: 5px 12px ;
  color: white;
}

.ariticle-btn:hover{
  transform: translateY(-5px);
  box-shadow: 0 7px 34px rgba(50,50,93,.1), 0 3px 6px rgb(0 0 0 / 10%);
  transition: all .5s;
}

@media screen and (max-width: 600px) {
    .content-row {
        flex-direction: column;
    }

    .content-thumb, .content-desc {
        margin-right: 0;
        width: 100%;
    }
}
.blog-block{
  margin-top:2rem;
}
.info{
  padding: 0 12px;
  display: block;
  width: 100%;
  box-sizing: border-box;
}
.notice{
   max-width: 560px;
  padding: 0.2em 0.5em;
  margin: 2em auto;
  letter-spacing: 1.5px;
  font-size: 12px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.room-change-btn {
  padding: 10px 20px;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
  transition: background-color 0.3s;
}

.room-change-btn.active {
  background-color: #4CAF50; /* Green */
}

.room-change-btn:not(.active) {
  background-color: #555; /* Darker */
}

.room-change-btn:hover {
  opacity: 0.8;
}

.room-container {
  margin-top: 20px;
}



.tool-content{
  margin: 36px auto 0 auto;
  max-width: 960px;
  width: 100%;
  padding: 30px;
}

.tool-content h1{
  text-align: center;
}

.tool-title{
  letter-spacing: 2px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
  font-size: 1.5rem;
  color:#212121;
  font-weight: bold;
}

.tool-sub-title{
  text-align: center;
}


.discord-list{
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  margin-top:48px;
  max-width:650px;
  margin: 0 auto;
}


@media screen and (max-width: 600px) {
  .discord-list{
    display: block;
  }
}

.discord-contents{
  width: 100%;
  height: auto;
}

.discord-name{
  margin-top: 12px;
  letter-spacing: 2px;
  font-size: 1rem;
}

.discord-preview{
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.35);
  background-color: #fafaf9;
  cursor: pointer;
	transition: .3s;
  width: auto;
  height: auto;
  max-width: 220px;
  border-radius: 15px;
  padding: 16px 24px 8px 24px;
  text-align: center;
  margin: 24px auto;
}

.discord-preview:hover {
	box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.35);
	transform: translateY(-4px);
}


.modal {
  display: block;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
  text-align: left;
}

.modal-content {
  background-color: #fefefe;
  margin: 5vh auto;
  padding: 20px;
  border: 1px solid #888;
  border-radius: 15px;
  width: 80%;

  max-width: 900px;
  min-height: 80vh;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.blog-area{
  padding: 20px;
  max-width: 620px;
  margin: 3rem auto;
  border-bottom: 1px solid #212121;
  border-top: 1px solid #212121;
}

.blog-area-title{
  margin-bottom: 20px;
  text-align: center;
  letter-spacing: 3px;
  text-shadow: 2px 2px 6px rgb(210 210 210 / 80%);
}

.blog-area-row{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  margin-top: 24px;
}

.blog-area-thumb{
  flex: 0 0 auto;
  margin-right: 20px;
  width: 50%;
}

.blog-area-thumb img{
    object-fit: contain;
    width: 100%;
}

.blog-area-desc{
  width: 50%;
  word-wrap: break-word;
  font-size: 14px;
  letter-spacing: 2px;
  text-align: left;
}

.blog-area-desc a{
  text-decoration:none;
}

.blog-area-btn{
  margin-top:2rem;
}

.check-btn{
  background-color: #212121;
  opacity: 0.75;
  border-radius: 8px;
  padding: 5px 12px ;
  color: white;
  transition: all .5s;
}

.check-btn:hover{
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.35);
	transform: translateY(-4px);
}
</style>